import React from 'react';
import PropTypes from 'prop-types';
import AIcon from './_atoms.icon';

export default function AFeaturedImage({ img, showVideo, onClick }) {
	let videoIcon;

	if (showVideo) {
		videoIcon = (
			<figcaption>
				<button className="a-button a-button--transparent" onClick={onClick}>
					<AIcon type="video" className="white" />
				</button>
			</figcaption>
		);
	}

	return (
		<figure className="a-featured-image">
			<img src={img} alt="" />
			{videoIcon}
		</figure>
	);
}

AFeaturedImage.propTypes = {
	img: PropTypes.string.isRequired,
	showVideo: PropTypes.bool,
	onClick: PropTypes.func,
};

AFeaturedImage.defaultProps = {
	showVideo: false,
	onClick: undefined,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.featured-image.js